<div class="p500-ui-modal__inner">
  <div class="p500-ui-modal__head">
    <div class="p500-ui-modal__close" (click)="closeModal()">
      <p500-ui-icon name="controls-close" size="24px"></p500-ui-icon>
    </div>
    <div class="p500-ui-modal__title c-modal__title" [ngClass]="{'-danger': modalType === MODAL_TYPES.DANGER}">
      <p500-ui-icon *ngIf="modalType === MODAL_TYPES.DANGER" class="mr-8" [name]="'other-danger'"></p500-ui-icon>
      {{ data.title }}
    </div>
    <div class="p500-ui-modal__subtitle">{{ data.subTitle }}</div>
  </div>
  <div class="p500-ui-modal__body">
    <div
      *ngIf="data.body === prettyBodyText; else elseTmpl"
      class="c-modal__message"
      [ngClass]="{'-danger': modalType === MODAL_TYPES.DANGER}"
      [innerHTML]="prettyBodyText"
    ></div>
    <ng-template #elseTmpl>
      <pre class="c-modal__message" [ngClass]="{'-danger': modalType === MODAL_TYPES.DANGER}">
        {{ prettyBodyText }}
      </pre>
    </ng-template>
    <span *ngIf="data.hasCopy" class="c-link c-link--primary -blue" (click)="copy($event)">
      <p500-ui-icon name="buttons-copy-big" p500UITooltip tooltipData="Copy to clipboard"></p500-ui-icon>
    </span>
  </div>
  <ng-container [ngSwitch]="data.footerType">
    <gtd-close-cancel-footer *ngSwitchCase="FOOTER_TYPES.CLOSE_CANCEL" [cancel]="footerCancel" [close]="onFooterClose">
    </gtd-close-cancel-footer>
  </ng-container>
</div>
